import React from 'react';
import classnames from 'classnames';
import _ from 'lodash';
import { useSecondaryModalStore } from '../../../../../stores';

const FIFTY_MINUTES = 3000000;

interface Booking {
  id: string | number;
  start_at: number;
  end_at: number;
}

interface Tutor {
  id: string | number;
}

interface SlotStatus {
  status: string;
}

interface CalendarTimeslotProps {
  tutor?: Tutor;
  tutorId?: string;
  timestamp?: number;
  status?: SlotStatus;
  timeZone?: string;
  studentBookings?: Booking[];
  duration?: number;
  onMouseEnter?: (timestamp: number) => void;
  onMouseLeave?: () => void;
  onClickSlot?: (timestamp: number) => void;
  myBookings?: Booking[];
  hoverStatus?: string;
}

const CalendarTimeslot: React.FC<CalendarTimeslotProps> = (props) => {
  const {
    duration,
    onMouseEnter,
    timestamp,
    myBookings,
    tutor,
    timeZone,
    onClickSlot,
    onMouseLeave,
    status,
    hoverStatus,
  } = props;
  const secondaryModalStore = useSecondaryModalStore();
  const handleMouseEnter = (e: React.MouseEvent) => {
    e.preventDefault();
    onMouseEnter?.(timestamp!);
  };

  const handleMouseLeave = (e: React.MouseEvent) => {
    e.preventDefault();
    onMouseLeave?.();
  };

  const onTouch = (e: React.TouchEvent) => {
    e.preventDefault();
    onClickSlot?.(timestamp!);
  };

  const onClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClickSlot?.(timestamp!);
  };

  const onTouchCancel = (e: React.TouchEvent) => {
    e.preventDefault();
    const dataBookingId = (e.target as HTMLElement).getAttribute(
      'data-booking',
    );
    const booking = _.find(myBookings, (b) => b.id === dataBookingId);
    if (booking) {
      secondaryModalStore.show('cancelBooking', {
        secondary: true,
        tutor,
        timeZone,
        booking,
      });
    }
  };

  const onClickCancel = (e: React.MouseEvent) => {
    e.preventDefault();
    const dataBookingId = (e.target as HTMLElement).getAttribute(
      'data-booking',
    );
    const booking = _.find(myBookings, (b) => b.id === dataBookingId);
    if (booking) {
      secondaryModalStore.show('cancelBooking', {
        secondary: true,
        tutor,
        timeZone,
        booking,
      });
    }
  };
  let timeslotDivClass = 'timeslot';
  let statusWords;
  let words: string | null = null;
  let wordsClass;
  let bookingId: string | number = 0;
  let handleClick: ((e: React.MouseEvent) => void) | undefined,
    handleTouch: ((e: React.TouchEvent) => void) | undefined;
  if (typeof status !== 'undefined') {
    statusWords = status.status;
    timeslotDivClass = classnames('timeslot', statusWords, hoverStatus);
    if (statusWords === 'cancel') {
      if (typeof myBookings !== 'undefined') {
        const booking = _.find(
          myBookings,
          (b) =>
            b.start_at === timestamp ||
            (b.start_at < timestamp! && b.end_at > timestamp!),
        );
        wordsClass = 'text-center';
        if (booking) {
          bookingId = booking.id;
          if (booking.end_at - booking.start_at === FIFTY_MINUTES) {
            if (booking.start_at === timestamp) {
              words = 'Cancel';
              wordsClass = 'text-center text-hovered-double';
            }
          } else {
            words = 'Cancel';
          }
        }
        handleClick = onClickCancel;
        handleTouch = onTouchCancel;
      }
    } else if (statusWords === 'on') {
      handleTouch = onTouch;
      if (hoverStatus === 'hover-down' || hoverStatus === 'hovered') {
        words = 'Book';
        wordsClass = classnames('text-center', {
          'text-hovered-double': +duration! === 1,
        });
        handleClick = onClick;
      }
    }
  }
  return (
    <div>
      <div
        className={timeslotDivClass}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={handleClick}
        onTouchEnd={(e) => {
          if (typeof handleTouch !== 'undefined') {
            handleTouch(e);
          }
        }}
      >
        <div data-booking={bookingId} className={wordsClass}>
          {words}
        </div>
      </div>
    </div>
  );
};

export default CalendarTimeslot;
